import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-post-activation',
    templateUrl: './post-activation.component.html',
    styleUrls: ['./post-activation.component.css', '../../../../../assets/css/amena-theme.css'],
    standalone: false
})
export class PostActivationComponent implements OnInit {
    @Input() activationError;
    @Input() error;
    @Output() retry = new EventEmitter<boolean>();
    ariaExpanded = false;
    showCollapse = true;
    constructor() { }

    ngOnInit(): void {
    }

    retryActivation() {
        this.retry.emit();
    }
}
